module.exports = __webpack_public_path__ + "img/3.b525253d.jpeg";